var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWechat = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 41.861 41.861"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "wechat_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h41.861v41.861H0z",
  "data-name": "Rectangle 7504"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 18869"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 18728"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  clipPath: "url(#wechat_svg__a)",
  "data-name": "Group 18727"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.581 12.039a10.32 10.32 0 0 0-8.455-.66 8.6 8.6 0 0 0-4.434 3.492 6.53 6.53 0 0 0-.814 5.015 7.67 7.67 0 0 0 3.328 4.5c-.3.867-.592 1.733-.869 2.607 1-.521 1.992-1.064 2.99-1.593a11.1 11.1 0 0 0 3.733.529 6.11 6.11 0 0 1 1.783-6.639 8.83 8.83 0 0 1 6.629-2.176 7.73 7.73 0 0 0-3.891-5.075m-6.822 3.947a1.253 1.253 0 1 1-1.634-1.479 1.262 1.262 0 0 1 1.634 1.479m6.181-.247a1.252 1.252 0 1 1-1.686-1.223 1.26 1.26 0 0 1 1.686 1.223",
  "data-name": "Path 27267"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.705 21.694a6.75 6.75 0 0 0-3.154-3.21 8.68 8.68 0 0 0-7.783.028 6.47 6.47 0 0 0-3.449 4.248 5.46 5.46 0 0 0 .694 4.043 7.45 7.45 0 0 0 5.072 3.308 9.3 9.3 0 0 0 4.426-.293c.857.335 1.624.874 2.456 1.272q-.319-1.078-.687-2.142a7 7 0 0 0 2.289-2.529 5.48 5.48 0 0 0 .136-4.725m-8.358.538a1 1 0 1 1-1.287-1.3 1.014 1.014 0 0 1 1.287 1.3m4.892.092a1.012 1.012 0 0 1-1.6.273 1.6 1.6 0 0 1-.352-.744 1.13 1.13 0 0 1 .955-.972 1.012 1.012 0 0 1 .993 1.443",
  "data-name": "Path 27268"
}))))));
export { SvgWechat as ReactComponent };
export default __webpack_public_path__ + "static/media/wechat.472b1370f214775bc56febf904f20cf1.svg";